import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedResponse } from '@/types';
import { API_BUSINESS_URL } from '@/utils';

export type SupportMaterialKind = 'VIDEO' | 'PDF' | 'IMAGE';

export interface SupportMaterial {
  id: string;
  title: string;
  description: string | null;
  kind: SupportMaterialKind;
  mimeType: string;
  sizeBytes: number;
  /** URL firmada de S3; vence en una hora. */
  url: string;
  createdByName: string | null;
  createdAt: string;
}

const supportMaterialsService = createApi({
  reducerPath: 'supportMaterialsService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}/support-materials`),
  tagTypes: ['SupportMaterials'],
  endpoints: (builder) => ({
    getSupportMaterials: builder.query<PaginatedResponse<SupportMaterial>, void>({
      query: () => ({ url: '', params: { limit: 100, offset: 0 } }),
      providesTags: ['SupportMaterials'],
    }),
    createSupportMaterial: builder.mutation<SupportMaterial, FormData>({
      query: (formData) => ({ url: '', method: 'POST', body: formData }),
      invalidatesTags: ['SupportMaterials'],
    }),
    deleteSupportMaterial: builder.mutation<void, string>({
      query: (id) => ({ url: `/${id}`, method: 'DELETE' }),
      invalidatesTags: ['SupportMaterials'],
    }),
  }),
});

export default supportMaterialsService;

export const {
  useGetSupportMaterialsQuery,
  useCreateSupportMaterialMutation,
  useDeleteSupportMaterialMutation,
} = supportMaterialsService;
